// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCK1WBXQCjTf6giU1m1Imsb20VkXlyurxQ",
  authDomain: "doorway-803de.firebaseapp.com",
  databaseURL: "https://doorway-803de-default-rtdb.firebaseio.com",
  projectId: "doorway-803de",
  storageBucket: "doorway-803de.appspot.com",
  messagingSenderId: "571511811406",
  appId: "1:571511811406:web:bfa6218306bca1cf34021f",
  measurementId: "G-J5HJ8P386W",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const messaging = getMessaging(app);

export const getTokenUserToken = (setTokenFound, cb) => {
  return getToken(messaging, {
    vapidKey: "BKZRNaVHXUrL8b42bfdQzeYno96q1ceGhF5RUBK1iI6VL73swsGcru51no15Dy1wz5qHWeeZA_Mrcfb3gMI0QO0",
  })
    .then(async (currentToken) => {
      if (currentToken) {
        // console.log('current token for client: ', currentToken);
        setTokenFound(true);
        // Track the token -> client mapping, by sending to backend server

        cb({ token: currentToken });

        // show on the UI that permission is secured
      } else {
        // console.log('No registration token available. Request permission to generate one.');

        cb({ token: null });
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

// Handle incoming messages while the app is in the foreground
onMessage(messaging, (payload) => {
  console.log("Foreground message received:", payload);
  // Handle foreground messages
});
